module.exports = __webpack_public_path__ + "img/ADI-Logo.dd22a126.png";